import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { Form } from 'react-final-form';
import { METERING_POINT_FORM } from '../../constants/formMeteringPoint';
import { meteringPointFields } from '../../constants/meteringPoint';
import {
  meteringPointDataSource,
  meteringPointType,
} from '../../constants/classificators';
import {
  updateMeteringPoint,
  updateConsumptionPoint,
} from '../../actions/actionCreators/meteringPointActionCreators';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import FormStateToRedux from '../FormStateToRedux';
import ConsumptionPoint from './ConsumptionPoint';
import ProductionPoint from './ProductionPoint';
import validateSchema from './validateSchema';

export class MeteringPointMain extends Component {
  static propTypes = {
    meteringPoint: PropTypesImmutable.map,
    t: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    updateMeteringPoint: PropTypes.func.isRequired,
    updateConsumptionPoint: PropTypes.func.isRequired,
    formApiRef: PropTypes.object,
  };

  onSubmit = async (values) => {
    const { meteringPoint } = this.props;
    const isProduction =
      meteringPoint?.get(meteringPointFields.METERING_POINT_TYPE) ===
      meteringPointType.PRODUCTION;
    const action = isProduction
      ? this.props.updateMeteringPoint
      : this.props.updateConsumptionPoint;
    const result = await action(values);
    if (result?.error) return;
  };

  render() {
    const { meteringPoint, t, isAdmin, formApiRef } = this.props;
    const initialValues = meteringPoint?.toJS
      ? meteringPoint.toJS()
      : meteringPoint || {};

    const isAvp =
      initialValues[meteringPointFields.DATA_SOURCE] ===
      meteringPointDataSource.AVP;
    const pointType = initialValues[meteringPointFields.METERING_POINT_TYPE];
    const productionUnit = initialValues[meteringPointFields.PRODUCTION_UNIT];

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      { isAvp, isAdmin, pointType },
      initialValues
    );

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit, form }) => {
          if (formApiRef) {
            formApiRef.current = form;
          }
          return (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={METERING_POINT_FORM} />
              {pointType === meteringPointType.PRODUCTION ? (
                <ProductionPoint
                  t={t}
                  isAvp={isAvp}
                  isAdmin={isAdmin}
                  productionUnit={productionUnit}
                />
              ) : (
                <ConsumptionPoint t={t} isAvp={isAvp} isAdmin={isAdmin} />
              )}
            </form>
          );
        }}
      />
    );
  }
}

const mapDispatchToProps = {
  updateMeteringPoint,
  updateConsumptionPoint,
};

export default connect(null, mapDispatchToProps)(MeteringPointMain);
